import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { UpdateFinanceTradesService } from "@/features/accounts/finance/services/update-trades-service";
import { PostFinanceTradesResponseModel } from "@/features/accounts/finance/services/update-trades-model";
//import { useAccountGroupsContext, Accounts } from "@/features/accounts/account-group/contexts/account-groups-context";


export const useUpdateFinanceTrades = () => {
  const { setError } = useContext(ErrorDialogContext);
  const loadingCtx = useContext(LoadingModalContext);
  const updateFinanceTradesService = new UpdateFinanceTradesService();
  
  // 銀行明細更新
  const updateFinanceTrades = async (
    accountGroupId: string,
    mlinkAccountId: string,
    mlinkId: string,
  ): Promise<PostFinanceTradesResponseModel | undefined> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await updateFinanceTradesService.updateFinanceTrades({
        account_group_id: accountGroupId,
        finance_account_id: mlinkAccountId,
        finance_id: mlinkId,
      });
        return res;
    } catch (error) {
      // エラーハンドリング
      console.log("updateFinanceTrades:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    updateFinanceTrades: errorHandledAsync(updateFinanceTrades, setError),
  };
};
